import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  loading: false,
  localization: { baseCurrency: '', localization: '', baseCurrencySign: '' }
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    saveConfigSuccessful(state, action) {
      state.sha1 = action.payload.sha1;
      state.version = action.payload.version;
      state.apiBaseUrl = action.payload.apiBaseUrl;
      state.balanceBaseUrl = action.payload.balanceBaseUrl;
      state.billingBaseUrl = action.payload.billingBaseUrl;
      state.gatewayBaseUrl = action.payload.gatewayBaseUrl;
      state.iamBaseUrl = action.payload.iamBaseUrl;
      state.minerBaseUrl = action.payload.minerBaseUrl;
      state.poolBaseUrl = action.payload.poolBaseUrl;
      state.landingBaseUrl = action.payload.landingBaseUrl;
      state.apiVersion = action.payload.apiVersion;
      state.error = null;
      state.loading = false;
    },
    setBaseCurrencySuccess(state, action) {
      state.localization.baseCurrency = action.payload;
      state.localization.localization =
        action.payload === 'EUR' ? 'de-DE' : 'en-US';
      state.localization.baseCurrencySign =
        action.payload === 'EUR' ? '€' : '$';
    },
    saveConfigFailed(state) {
      state.loading = false;
      state.error = true;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setLocalization: (state, action) => {
      state.localization = { ...state.localization, ...action.payload };
    },
    setLoading(state, action) {
      state.loading = action.payload;
    }
  }
});

export const {
  saveConfigSuccessful,
  setBaseCurrencySuccess,
  saveConfigFailed,
  setUserType,
  setLocalization,
  setLoading
} = configSlice.actions;

export default configSlice.reducer;
